import clsx from "clsx";
import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { Icon } from "../../../icon";

export interface NestedHeaderMenuItemProps extends Queries.HeaderMenuItemDataFragment {
  className?: string;
  iconClassName?: string;
}

export const NestedHeaderMenuItem: FC<NestedHeaderMenuItemProps> = ({
  id,
  title,
  tabs,
  className,
  iconClassName,
}) => {
  const { toggleExpandedItemId, isItemPanelExpanded, expandedItemId } = useHeaderMenu();
  const isActive = isItemPanelExpanded && expandedItemId === id;
  return (
    <button
      type="button"
      onClick={() => toggleExpandedItemId(id)}
      className={clsx(
        "text-light lg:text-dark",
        "hover:underline cursor-pointer flex items-center gap-1 lg:gap-0",
        isActive && "underline",
        className
      )}
    >
      {title}
      {(tabs ?? []).length >= 0 && (
        <Icon
          icon="chevron-up-thick"
          className={clsx(
            "h-4",
            !isActive ? "rotate-90 lg:rotate-180 mr-1 lg:mr-0 lg:mt-1" : "",
            iconClassName
          )}
        />
      )}
    </button>
  );
};
